import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';

import SimpleEditor from "../../components/Editor/SimpleEditor";
import DragAndDrop from "../../components/DragAndDrop/DragAndDrop";
import Notification from '../../components/Notification/Notification';
import EntryNotifications from "./EntryNotifications";

import {API_HOST, fetcher} from '../../config/config';

const defaultProps = {
  body: "",
  user_id: 0,
  entry_id: 0,
  recipients_list: [],
};

export default function EntryForm(props){
	const {project_id, tab_id, entry_id} = useParams();
  const [disabledSave, setDisabledSave] = useState(true);
  const [comment, setComment] = useState(defaultProps);
	const [response, setResponse] = useState({message: '', type: ''});
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [uploads, setUploads] = useState([]);

  const onBodyChange = (e) => {
    comment.body = e.target.value;
    setComment({...comment});
  }

  const onRecipientsChange = (recipients) => {
    comment.recipients_list = recipients;
    setComment({...comment});
  }

  const onDrop = (files) => {
    if (files.length !== 0) {
      setUploads([...files]);
    }
    if (files.length === 0) {
      setUploads([]);
    }
  }

  const validate = () => {
    if (comment.body.length === 0) {
      setResponse({type: 'danger', message: "Bitte geben Sie Ihren Kommentar ein"});
      return false;
    }
    return true;
  }

  const onSave = async () => {
		(async () => {

      props.onSaving(true);

      if (!validate()) {
        props.onSaving(false);
        return;
      }

      try {
        comment.uploads = uploads.map(item => {
          return {
            serverId: item.serverId,
            fileSize: item.fileSize,
            filename: item.filename
          }
        })

        await fetcher(`${API_HOST}projects/${project_id}/tabs/${tab_id}/entries/${entry_id}/comments`, 'POST', comment);

        setResponse({type: 'success', message: 'Erfolgreich gespeichert'});
        window.location.reload();

			} catch (error) {
        props.onSaving(false);
				setResponse({type: 'danger', message: error?.message});
			}
		})();
  }

	return (
    <section className="mb-5 border-bottom pb-4">
      <Notification message={response}/>

      <p><strong><img src="/assets/icons/edit.svg" alt="File"/> Neuer Kommentar</strong></p>
        <div className="mb-3">
          <label htmlFor="comment" className="form-label visually-hidden">Kommentartext</label>
          <SimpleEditor value={comment.body} onChange={onBodyChange} className="form-control"/>
        </div>

        <DragAndDrop onDrop={onDrop} setUploadFiles={(uploads => setUploads(uploads))} setFileIsUploading={(isUploading => setIsFileUploading(isUploading))}/>

        <EntryNotifications tab={props.tab} onUserSelection={(users)=> onRecipientsChange(users)} onStatusChange={(status) => setDisabledSave(status)}/>

        <div className="mb-3">
          <button type="submit" className="btn btn-primary" disabled={disabledSave || isFileUploading || props.isSaving} onClick={onSave}>
            {props.isSaving ? 'Wird gespeichert...' : 'Kommentar absenden'}
          </button>
        </div>
    </section>
  )
}
